import React, { FC, ReactElement } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { FmBox } from "../FmBox";
import { useStyles } from "./FmCarbonFootprintBanner.style";
import { useIsMobile, useTheme } from "../../Hooks";
import { Box, Stack, Typography } from "@mui/material";
import { FmButton } from "../FmButton";
import { ShowWhen } from "../ShowWhen";

interface FmCarbonFootprintBannerProps {
    children?: ReactElement | ReactElement[];
    title?: string;
    description?: string;
    buttonText?: string;
    onClick?: () => any;
    onClose?: () => any;
}

export function FmCarbonFootprintBanner(props: FmCarbonFootprintBannerProps) {
    const styles = useStyles();
    const theme = useTheme();
    const isMobile = useIsMobile();

    function getWrapperClasses() {
        // If is mobile we return the mobile styles
        if (isMobile) {
            return styles.mainContainerMobile;
        }

        // If there is a button attached to the component
        // we return the fitting styles
        if (!props.onClick) {
            return styles.mainContainerNoButton;
        }

        // We return the regular styles if nothing special is going on
        return styles.mainContainer;
    }

    return (
        <FmBox className={getWrapperClasses()} variant='gray'>
            <img className={isMobile ? styles.co2LogoMobile : styles.co2Logo} src={theme.images.co2Logo} alt='co2' />

            <Box sx={{ width: props.onClick ? 60 : 0 }}></Box>

            <Box className={styles.textContainer}>
                <ShowWhen when={props.title && props.title.trim().length > 0}>
                    <Typography className={styles.title}>{props.title}</Typography>
                </ShowWhen>

                <ShowWhen when={props.description && props.description.trim().length > 0}>
                    <Typography className={styles.text}>{props.description}</Typography>
                </ShowWhen>
            </Box>

            <ShowWhen when={!isMobile}>
                <Box className={styles.buttonsContainer}>
                    <ShowWhen when={props.onClose}>
                        <CloseIcon className={styles.closeIcon} onClick={props.onClose} />
                    </ShowWhen>

                    <ShowWhen when={props.onClick && props.buttonText && props.buttonText.trim().length > 0}>
                        <FmButton onClick={props.onClick} type='button' fullWidth='fullWidth'>
                            {props.buttonText}
                        </FmButton>
                    </ShowWhen>
                </Box>
            </ShowWhen>

            <ShowWhen when={isMobile}>
                <Stack direction='column'>
                    <ShowWhen when={props.onClose}>
                        <CloseIcon className={styles.closeIconMobile} onClick={props.onClose} />
                    </ShowWhen>

                    <ShowWhen when={props.onClick && props.buttonText && props.buttonText.trim().length > 0}>
                        <Box marginTop={1}>
                            <FmButton onClick={props.onClick} type='button' fullWidth='fullWidth'>
                                {props.buttonText}
                            </FmButton>
                        </Box>
                    </ShowWhen>
                </Stack>
            </ShowWhen>
        </FmBox>
    );
}
